<template>
   <div class="wrapper">
      <div class="d-flex align-items-center justify-content-between">
         <h1 class="title mb-2">
            <slot>{{ title }}</slot>
         </h1>
      </div>
      <hr class="my-0" />
   </div>
</template>

<script>
export default {
   props: {
      title: {
         type: String,
      },
   },
};
</script>

<style lang="scss" scoped>
.wrapper {
   margin-bottom: 1rem;
}

.title {
   font-size: 2rem;
   font-weight: 700;
   color: #000;
}
</style>
